export const CURRENCY = "EGP";